// ============================================================
//  src/data/mobs.js  —  SimpleMC mob registry
//  Add a new object here → a full wiki page is auto-generated.
// ============================================================

const mobs = [
  {
    id: 'bloodrot-zombie',
    name: 'Bloodrot Zombie',
    icon: '💀',
    tier: 'rare',           // common|uncommon|rare|elite|epic|legendary|boss
    type: 'Undead',
    glowColor: 'rgba(224,72,72,0.14)',
    description:
      'A festering undead mutant infected with ancient rot. Inflicts Wither on hit and can call nearby undead to its aid.',
    lore:
      "They say the first Bloodrot rose from the mass graves beneath the Ashvault — cursed by whatever dark force sealed the vault shut centuries ago.",
    stats: { hp:180, hpMax:600, damage:11, dmgMax:40, defense:15, defMax:100, speed:4, spdMax:10 },
    xp: 120,
    spawn: {
      biomes:    [{ name:'Caves', icon:'🕳️' }, { name:'Graveyards', icon:'⚰️' }],
      locations: [{ name:'The Ashvault', icon:'🏚️' }, { name:'Ironkeep Fort', icon:'🏯' }],
      time:   'Night',
      method: 'Natural spawn below Y=60 in darkness. 15% chance to spawn as a group of 3 when first alerted.',
      rarity: 'uncommon',
    },
    abilities: [
      { icon:'🩸', name:'Wither Strike',  type:'Passive · On Hit', description:'Every hit applies Wither I for 4 seconds. Resets duration if target is already withered.', cooldown:null },
      { icon:'📣', name:'Rally the Dead', type:'Active',            description:'Below 40% HP, shrieks to call up to 3 nearby undead. Triggers once per encounter.',          cooldown:'60s' },
    ],
    drops: [
      { icon:'🧟', name:'Rotten Core',    rarity:'common',   chance:'80%', note:'Basic potion crafting' },
      { icon:'💨', name:'Wither Dust',    rarity:'uncommon', chance:'30%', note:'Crafts Decay Arrows' },
      { icon:'💀', name:'Bloodrot Skull', rarity:'rare',     chance:'10%', note:'Necromancer helmet recipe' },
      { icon:'📦', name:'Scrap Iron',     rarity:'common',   chance:'60%', note:null },
    ],
    tips: [
      'Carry a Milk Bucket — instantly cleanses Wither.',
      'Burst it down before 40% HP to prevent Rally the Dead.',
      'Looting III notably improves Bloodrot Skull chance.',
    ],
  },

  {
    id: 'ironback-spider',
    name: 'Ironback Spider',
    icon: '🕷️',
    tier: 'elite',
    type: 'Arthropod',
    glowColor: 'rgba(139,160,174,0.12)',
    description:
      'A heavily armoured arachnid nesting in coastal ruins. Its iron-fused carapace makes it immune to arrows — bring a melee weapon.',
    lore:
      "Sailors once reported enormous spiders weaving webs between the masts of sunken ships. Nobody believed them. Now everyone does.",
    stats: { hp:260, hpMax:600, damage:14, dmgMax:40, defense:55, defMax:100, speed:6, spdMax:10 },
    xp: 200,
    spawn: {
      biomes:    [{ name:'Coastal Ruins', icon:'⛵' }],
      locations: [{ name:'Sunken Docks', icon:'🚢' }],
      time:   'Any',
      method: 'Spawns in web-covered warehouses in groups of 2–4. Does not despawn once aggro\'d.',
      rarity: 'uncommon',
    },
    abilities: [
      { icon:'🛡️', name:'Iron Shell',  type:'Passive',       description:'Immune to all projectile damage (arrows, tridents, snowballs).', cooldown:null },
      { icon:'🕸️', name:'Web Snare',   type:'Active · AOE',  description:'Fires a web at target location, applying Slowness IV for 3s.', cooldown:'12s' },
      { icon:'⚡',  name:'Lunge',       type:'Active',        description:'Leaps up to 8 blocks at a target, dealing 200% normal damage on impact.', cooldown:'20s' },
    ],
    drops: [
      { icon:'🧵', name:'Spider Silk',      rarity:'common',   chance:'90%', note:'Basic crafting' },
      { icon:'🪡', name:'Iron Silk Thread', rarity:'rare',     chance:'25%', note:'Ironback Axe recipe' },
      { icon:'🪲', name:'Carapace Shard',   rarity:'epic',     chance:'8%',  note:'Armour upgrade mat' },
    ],
    tips: [
      'Arrows deal zero damage — always use melee.',
      'Back into a corner to neutralise the Lunge.',
      'Jump just before Web Snare lands to avoid Slowness.',
    ],
  },

  {
    id: 'the-watcher',
    name: 'The Watcher',
    icon: '👁️',
    tier: 'boss',
    type: 'Ancient · Boss',
    glowColor: 'rgba(160,112,224,0.2)',
    description:
      'An ancient entity sealed inside the Ashvault. The most dangerous boss on the server — drops the rarest crafting materials in the game. Do not fight alone.',
    lore:
      "It has no name in any language we know. The scholars who found it called it The Watcher because — whatever it is — it never stops looking at you.",
    stats: { hp:1200, hpMax:1500, damage:32, dmgMax:40, defense:40, defMax:100, speed:3, spdMax:10 },
    xp: 2000,
    spawn: {
      biomes:    [{ name:'Underground', icon:'🕳️' }],
      locations: [{ name:'Ashvault — Deepest Chamber', icon:'🏚️' }],
      time:   'Any',
      method: 'Respawns every 3 hours. Requires a Skeleton Key. Announced server-wide on spawn.',
      rarity: 'legendary',
    },
    abilities: [
      { icon:'👁️', name:'Death Gaze',    type:'Targeted Beam', description:'Locks a gaze beam onto one player, dealing 8 dmg/s for 5s. Breaking LoS cancels it.',         cooldown:'18s' },
      { icon:'🌑', name:'Void Pulse',    type:'AOE',           description:'12-block AOE: 18 damage + Blindness VI for 6s to all players hit.',                             cooldown:'30s' },
      { icon:'💀', name:'Summon Hollow', type:'Summon',        description:'Summons 2 Hollowed Knights at 60% and again at 30% HP.',                                        cooldown:null  },
      { icon:'🛡️', name:'Phase Shield',  type:'Reactive',      description:'Gains 70% damage reduction for 8s whenever it summons minions.',                               cooldown:null  },
    ],
    drops: [
      { icon:'🌑', name:'Shadow Shard',  rarity:'rare',      chance:'100%', note:'Always drops 2–4' },
      { icon:'👁️', name:"Watcher's Eye", rarity:'legendary', chance:'45%',  note:"Core mat for Watcher's Staff" },
      { icon:'💜', name:'Void Essence',  rarity:'epic',      chance:'70%',  note:'Top-tier weapon crafting' },
      { icon:'🗝️', name:'Ashvault Key',  rarity:'rare',      chance:'60%',  note:'Opens a locked Ashvault room' },
    ],
    tips: [
      'Bring at least 3 players — solo is not viable.',
      'Step sideways when Death Gaze locks on — LoS break cancels it instantly.',
      'Kill Hollowed Knights fast or they overwhelm during Phase Shield.',
      'Fire Resistance pots reduce Void Pulse damage by 25%.',
    ],
  },

  {
    id: 'ridgeback-drake',
    name: 'Ridgeback Drake',
    icon: '🐉',
    tier: 'legendary',
    type: 'Dragon · Boss',
    glowColor: 'rgba(224,72,72,0.16)',
    description:
      'A rare mini-boss drake nesting on Ridgeback Summit. Its scales make the best armour in the game. Only one can exist at a time — announced server-wide on spawn.',
    lore:
      "The old maps called this mountain Dragon's Rest. People thought it was just a name. It wasn't just a name.",
    stats: { hp:800, hpMax:1500, damage:26, dmgMax:40, defense:60, defMax:100, speed:5, spdMax:10 },
    xp: 1500,
    spawn: {
      biomes:    [{ name:'Mountain Peak', icon:'🏔️' }],
      locations: [{ name:'Ridgeback Summit', icon:'⛰️' }],
      time:   'Any',
      method: 'Respawns 4 hours after death. Only one Drake alive at a time. Server-wide announcement on spawn and death.',
      rarity: 'legendary',
    },
    abilities: [
      { icon:'🔥', name:'Drakefire Breath', type:'Channelled · Cone', description:'Cone of fire, 6 dmg/tick, sets ground ablaze. Lasts 4s.', cooldown:'20s' },
      { icon:'🌪️', name:'Wing Gust',         type:'AOE · Knockback',  description:'Knocks all players within 10 blocks back 6 blocks + 10 damage.', cooldown:'14s' },
      { icon:'🛡️', name:'Scale Armour',      type:'Passive',          description:'Reduces all damage by 35%. Immune to fire.', cooldown:null },
      { icon:'💥', name:'Tail Slam',          type:'Melee · Stun',     description:'22 damage + 1.5s stun to nearest player.', cooldown:'10s' },
    ],
    drops: [
      { icon:'🦴', name:'Drake Bone',  rarity:'uncommon',  chance:'100%', note:'Always drops 3–6' },
      { icon:'🟠', name:'Drake Scale', rarity:'legendary', chance:'60%',  note:'Drake Scale Armour mat' },
      { icon:'❤️', name:'Drakeheart',  rarity:'legendary', chance:'20%',  note:'Top-tier weapon core' },
      { icon:'🔥', name:'Ember Sac',   rarity:'epic',      chance:'50%',  note:'Fire weapons & potions' },
    ],
    tips: [
      'Fire Resistance potion is mandatory — Drakefire will one-shot you without it.',
      'Stand behind the Drake to avoid Breath; wing-spread telegraphs Wing Gust.',
      'Drake Scale Armour is the best in the game and trivialises future fights.',
      'Rotate aggro — Tail Slam always targets the closest player.',
    ],
  },

  {
    id: 'ashfang-wolf',
    name: 'Ashfang Wolf',
    icon: '🐺',
    tier: 'uncommon',
    type: 'Beast',
    glowColor: 'rgba(224,168,50,0.12)',
    description:
      'A fast pack hunter roaming the Scorched Wastes. Individually manageable; in a pack of 6 it becomes lethal very quickly.',
    lore:
      "They don't howl. They never howl. You only know they're there when three of them are already on top of you.",
    stats: { hp:90, hpMax:600, damage:9, dmgMax:40, defense:5, defMax:100, speed:8, spdMax:10 },
    xp: 65,
    spawn: {
      biomes:    [{ name:'Volcanic Plains', icon:'🌋' }, { name:'Ash Flats', icon:'🏜️' }],
      locations: [{ name:'Scorched Wastes', icon:'🔥' }],
      time:   'Day',
      method: 'Spawns in packs of 3–6. If one wolf is attacked, all within 24 blocks are alerted.',
      rarity: 'common',
    },
    abilities: [
      { icon:'🐾', name:'Pack Hunt', type:'Passive',  description:'+3 bonus damage per additional Ashfang Wolf within 16 blocks (max +12).', cooldown:null },
      { icon:'🩸', name:'Hamstring',  type:'On Hit',  description:'20% chance to apply Slowness II for 3s.',                                cooldown:null },
    ],
    drops: [
      { icon:'🦴', name:'Ash Bone',     rarity:'common',   chance:'85%', note:null },
      { icon:'🧥', name:'Ashfang Pelt', rarity:'uncommon', chance:'40%', note:'Crafts Ashfang Cloak' },
      { icon:'🦷', name:'Alpha Fang',   rarity:'rare',     chance:'5%',  note:'Only from the pack leader (glowing red eye)' },
    ],
    tips: [
      'Pull one wolf away from the pack before engaging — Pack Hunt stacks fast.',
      'The pack leader has a glowing red eye and is slightly larger.',
      'Separate the pack before engaging to reduce Pack Hunt bonus.',
    ],
  },
];

export default mobs;
